export default "__VITE_ASSET__1a9e5a5b__"